(() => {
  const init = () => document.querySelectorAll('[data-ma-video-hero]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const video = root.querySelector('video');
    const button = root.querySelector('[data-video-toggle]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = Boolean(navigator.connection && navigator.connection.saveData);
    let manuallyPaused = false;
    let visible = root.getBoundingClientRect().top < window.innerHeight;
    let queued = false;
    const draw = () => {
      queued = false;
      const rect = root.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      const progress = motion.matches ? 0 : Math.min(1, Math.max(0, window.scrollY / Math.max(1, top + root.offsetHeight * 0.65)));
      root.style.setProperty('--ma-reveal', String(progress));
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(draw); } };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    const syncButton = () => {
      if (!button || !video) return;
      button.textContent = video.paused ? button.dataset.play : button.dataset.pause;
      button.setAttribute('aria-label', button.textContent);
    };
    const play = () => {
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(syncButton);
    };
    const auto = () => {
      if (!video) return;
      if (!visible || document.hidden || motion.matches || saveData || manuallyPaused) video.pause();
      else play();
    };
    if (video) {
      video.muted = true;
      video.controls = false;
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) {manuallyPaused = false; play();}
          else {manuallyPaused = true; video.pause();}
        });
      }
      video.addEventListener('play', syncButton);
      video.addEventListener('pause', syncButton);
      video.addEventListener('error', () => {video.hidden = true; if (button) button.hidden = true;});
      if ('IntersectionObserver' in window || typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(entries => {visible = entries[0].isIntersecting; auto();}, {threshold:0.05}).observe(root);
      } else auto();
      document.addEventListener('visibilitychange', auto);
      syncButton();
    }
    motion.addEventListener('change', () => {draw(); auto();});
    draw();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
